import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'access-sms',
  version: '1.0.0',
  properties: [
    {
      key: 'to',
      label: 'To',
      type: 'string',
      required: true,
      placeholder: '+44123456789',
      description: 'Recipient phone number in E.164 format (e.g., +44123456789). Supports comma-separated numbers for multiple recipients.',
    },
    {
      key: 'body',
      label: 'Message',
      type: 'text',
      required: true,
      placeholder: 'Your SMS message here...',
      description: 'The SMS message content (max 1600 characters for concatenated SMS)',
      typeOptions: {
        rows: 4,
      },
    },
    {
      key: 'enableMms',
      label: 'Include Media (MMS)',
      type: 'boolean',
      default: false,
      description: 'Send as MMS with media attachments',
    },
    {
      key: 'mediaUrls',
      label: 'Media URLs',
      type: 'string',
      default: '',
      placeholder: 'https://example.com/image.jpg',
      description: 'Comma-separated URLs of media to attach (max 10 URLs, supported: JPG, GIF, PNG, PDF)',
      displayOptions: {
        show: {
          enableMms: [true],
        },
      },
    },
    {
      key: 'statusCallback',
      label: 'Status Callback URL',
      type: 'string',
      default: '',
      placeholder: 'https://your-webhook.com/sms-status',
      description: 'Webhook URL to receive delivery status updates (optional)',
      section: 'settings',
    },
    {
      key: 'validityPeriod',
      label: 'Validity Period (seconds)',
      type: 'number',
      default: 14400,
      description: 'How long (in seconds) the message can remain in queue if undeliverable (default: 4 hours)',
      section: 'settings',
    },
  ],
};

export default schema;
